import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '20px',
  height = '20px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...other}
      color={color ? color : 'primaryText'}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8.518 12.074 7.926 18l7.703-8.296-4.148-2.37L12.074 2 4.37 10.296l4.148 1.778Z"
      />
    </Box>
  );
}
